require('bowser');
require('./js/infinite-scroll.js');
require('./js/cookieconsent.js');
require('./js/frontend.js');

require('./css/frontend.css');
require('./css/frontend.calendar.css');
